import { format } from 'date-fns';
import { supabase } from '@/lib/supabase';

/**
 * Generates a credit note number in the format CNddMMyy#SS
 * Example: CN101224#01 (December 10, 2024, first credit note of the day)
 */
export const generateCreditNoteNumber = async (companyId: string): Promise<string> => {
  const today = new Date();
  const datePrefix = `CN${format(today, 'ddMMyy')}`;
  
  // Count existing credit notes for today for this company
  const { count, error } = await supabase
    .from('customer_credits')
    .select('*', { count: 'exact', head: true })
    .like('credit_note_number', `${datePrefix}%`);

  if (error) {
    console.error('Error counting credit notes:', error);
    throw new Error('Failed to generate credit note number');
  }
  
  const sequence = String((count || 0) + 1).padStart(2, '0');
  return `${datePrefix}#${sequence}`;
};
